import React, {Component} from "react";
import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import * as ReactBootStrap from "react-bootstrap";
import filterFactory, {
  numberFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "./Tables.css";
let columnsData = [];

class Tables extends Component {
  constructor(props) {
    super(props);
    console.log(this.props.module);
    this.state = {
      columns: [],
    };
    this.getTablesData();
  }
  getTablesData = () => {
    let allTableData = [];
    allTableData = [];
    // to store all tables data (Labels name, sortable and filter Type)
    var label = [];
    var sortable = [];
    var filterType = [];
    var DataArr = {
      labels: label,
      sortable: sortable,
      filterType: filterType,
    };
    columnsData = [];
    // Push every type of information in one place ("labels, sortable or filterType")
    for (let x = 0; x < this.props.module.fields.length; x++) {
      let field = this.props.module.fields[x];
      label.push(field.label);
      sortable.push(field.sortable);
      filterType.push(field.filterType);
    }
    allTableData.push(DataArr);

    // To store all tables columns
    for (let c = 0; c < allTableData.length; c++) {
      let columnsDataStore = [];
      columnsData.push(columnsDataStore);
      for (let i = 0; i < allTableData[c].labels.length; i++) {
        columnsDataStore.push({
          dataField: allTableData[c].labels[i],
          text: allTableData[c].labels[i],
          sort: allTableData[c].sortable[i] ? true : false,
          filter:
            allTableData[c].filterType[i] === "textFilter"
              ? textFilter({style: {width: "150px"}})
              : allTableData[c].filterType[i] === "numberFilter"
              ? numberFilter({numberStyle: {width: "150px"}})
              : false,
        });
      }
    }
  };
  // The "getDerivedStateFromProps" method is called right before rendering the element(s) in the DOM
  // And update the data eveytime the component rendered
  static getDerivedStateFromProps(props, state) {
    return {columns: columnsData};
  }
  render() {
    this.getTablesData();
    console.log(this.state);
    let tableHTML = [];
    tableHTML = [];
    // Restore the compenent in "tableHTML" and render it below
    tableHTML.push(
      <div
        className="tableContainer"
        key={Math.random()}
        id={this.props.module.id}
      >
        <h2 className="text-center mt-4 mb-4">{this.props.module.title}</h2>
        <BootstrapTable
          bootstrap4
          keyField="name"
          data={this.props.module.data}
          columns={this.state.columns[0]}
          filter={filterFactory()}
          // pagination={paginationFactory()}
        />
      </div>
    );

    return <div className="allDataContainer">{tableHTML}</div>;
  }
}

export default Tables;
